<div *ngIf="content.activities" class="skymiles-landing-page-earns-summary">
  <aura-toggle-area
    [entryItem]="content.toggle"
    [separator]="false"
    [stylesArray]="expanderStyle"
    [textEllipsis]="false"
    auraCustomStyles
  >
    <div class="skymiles-landing-page-earns-summary__action">
      <idp-link
        [actionUrl]="content.action.url"
        [axLabel]="content.ariaLabels.action"
        [labelSize]="'normal'"
        [label]="content.action.label"
        [id]="content.action.id || '#'"
        [stylesArray]="actionStyles"
        auraCustomStyles
      ></idp-link>
    </div>

    <div
      class="skymiles-landing-page-earns-summary__entry-item"
      *ngFor="let activity of content.activities"
      [id]="activity.id"
    >
      <aura-entry-item
        [entryItem]="activity"
        [textEllipsis]="false"
        [stylesArray]="entryItemStyle"
        auraCustomStyles
      ></aura-entry-item>
      <aura-divider
        [stylesArray]="dividerStyle"
        auraCustomStyles
      ></aura-divider>
    </div>

    <div class="skymiles-landing-page-earns-summary__action">
      <div class="skymiles-landing-page-earns-summary__footer">
        {{ content.summary.label }}
      </div>
      <div>
        <button
          class="skymiles-landing-page-earns-summary__icon"
          auraTooltip
          [tooltipContent]="content.summary.tooltip"
        >
          <img alt="info icon" />
        </button>
      </div>
    </div>
  </aura-toggle-area>
</div>
